import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import LocaleSetting from './Locale';
import GET_HWT_CLASSROOM_SETTINGS from 'graph/settings/hwt/get-hwt-classroom-settings-query';
import { Classroom } from 'types/schema-generated-types';

interface GssSettingsProps {
  classroom: Classroom;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const ClassroomHwtSettings: FC<GssSettingsProps> = ({
  classroom,
  expanded,
  handleChangeExpanded
}) => {
  const { id: classroomId } = classroom;
  const { data, loading } = useQuery(GET_HWT_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    }
  });

  return (
    <PageContainer loading={loading}>
      <LocaleSetting
        panel={'locale'}
        classroom={classroom}
        setting={data?.hwtClassroomSettings?.locale}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default ClassroomHwtSettings;
